// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less';
import md5 from 'js-md5';
import httpRequest from '../src/component/httpRequest';
import {Base64} from 'js-base64'
import $ from 'jquery'

Vue.use(less);
Vue.use(ElementUI);
Vue.use(Base64);

Vue.prototype.md5 = md5;
Vue.config.productionTip = false;
Vue.prototype.$axios = httpRequest;


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js